import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import FrameQrColor from "./frameQrColor";
import FrameTextColor from "./frameTextColor";
import FrameTextInput from "./frameTextInput";
import QrFrameWrapper from "./QrFrameWrapper";
import {
  qrFrame,
  qrFrameTransform,
  qrFrameTransformText,
} from "../../../../redux/slices/qrFrames";
import NoTemplate from "./svg/NoTemplate";
import FrameTextFont from "./frameTextFont";
import { Col, Row } from "react-bootstrap";
import styled from "styled-components";
import useFrames from "../../../../hooks/useFrames";
import {
  setFramesModalCategory,
  setIsFramesModal,
} from "../../../../redux/slices/modals";
import FrameCategoryBlock from "./frameCategoryBlock";
import HolidayFrameBlock from "./holidayFrameBlock";
import useWindowSize from "../../../../hooks/useWindowSize";
import axios from "axios";
import PreMadeFrames from "./preMadeFrames";
import QrPatternBackgroundToggle from "../ShapeColorWrapper/QrPatternBackgroundToggle";
import QrPatternBackground from "../ShapeColorWrapper/QrPatternBackground";
import PalleteIcon from "./frameCategoryBlock/svg/PalleteIcon";
import useCurrentLocation from "../../../../hooks/useCurrentLocation";
import FrameTextSize from "./frameTextSize";

function QrFrameItems() {
  const { lang, langFrame, qrFrames, lang2 } = useSelector((state) => ({
    lang: state.changeLang.language.stepThree.frame,
    langFrame: state.changeLang.language.modalFrames,
    qrFrames: state.qrFrames,
    lang2: state.changeLang.language.stepThree.showToggle,
  }));

  const holidayFrames = {
    womensDay: langFrame[12],
    halloween: langFrame[5],
    tequila: langFrame[14],
    newYear: langFrame[34],
    valentine: langFrame[11],
    easter: langFrame[13],
    aprilFoolDay: langFrame[15],
    eidAlFitr: langFrame[17],
    laborDay: langFrame[18],
    prophetMuhammad: langFrame[19],
    songkran: langFrame[20],
    fathersDay: langFrame[21],
    panchashila: langFrame[22],
    indonesia: langFrame[23],
    hungKings: langFrame[24],
    harvest: langFrame[25],
    thanksgiving: langFrame[26],
    brazilianCarnival: langFrame[27],
    holi: langFrame[28],
    columbus: langFrame[29],
    christmas: langFrame[16],
    chinaNewYear: langFrame[35],
    tet: langFrame[36],
  };
  const eventsFrames = {
    birthChild: langFrame[30],
    birthday: langFrame[31],
    anniversary: langFrame[32],
    wedding: langFrame[33],
  };
  const thematicArr = {
    food: langFrame[6],
    travel: langFrame[7],
    shopping: langFrame[8],
    jobs: langFrame[9],
    beauty: langFrame[10],
  };
  const standartFrames = { standart: langFrame[4] };

  const dispatch = useDispatch();
  const { frameConfigs } = useFrames();
  const { isDesktop } = useWindowSize();
  const { isTemplateService } = useCurrentLocation();

  const [frame, setFrame] = useState(qrFrames.frame);

  const [frameTransform, setFrameTransform] = useState(qrFrames.frameTransform);

  const [frameTransformText, setFrameTransformText] = useState(
    qrFrames.transformFrameText
  );
  const [recentlyFrameNames, setRecentlyFrameNames] = useState([]);

  useEffect(() => {
    setFrame(qrFrames.frame);
    setFrameTransform(qrFrames.frameTransform);
    setFrameTransformText(qrFrames.transformFrameText);
  }, [qrFrames]);

  useEffect(() => {
    dispatch(qrFrame(frame));
    dispatch(qrFrameTransform(frameTransform));
    dispatch(qrFrameTransformText(frameTransformText));
  }, [frame, frameTransform, frameTransformText]);

  const handleViewMore = (category) => {
    dispatch(setFramesModalCategory(category));
    dispatch(setIsFramesModal(true));
  };

  useEffect(() => {
    if (isTemplateService) {
      return;
    }
    const fetchRecentlyUsed = async () => {
      const { data } = await axios(
        "/qr-code-generator-template/get-qr-recently-used"
      );
      const framesData = data.map((item) => JSON.parse(item));
      const frameNames = [];
      framesData.forEach((item) => {
        if (item?.qrFrames?.frame) {
          frameNames.push(item.qrFrames.frame);
        }
      });
      setRecentlyFrameNames(frameNames);
    };

    fetchRecentlyUsed();
  }, []);

  const isStandartFrame = useMemo(() => {
    return frameConfigs.find((item) => item.name === frame)?.categoryId === 1;
  }, [frame]);

  return (
    <>
      <PreMadeFrames />

      <section
        className="bg-white p-3 p-md-4 mt-3 mbt-lg-4 text-capitalize rounded-1"
        id="frames"
      >
        <Row className="d-flex justify-content-between alignt-itens-center mb-3 mb-md-4">
          <Col xs="auto">
            <div className="fw-bold fs-4">{lang2[0]}</div>
          </Col>
          <Col xs={5} md={2}>
            <div
              className="text-white fw-bold w-100 btn btn-primary fs-7"
              onClick={() => handleViewMore("standart")}
            >
              {lang[10]}
            </div>
          </Col>
        </Row>

        <Row className="gy-3 gy-lg-4 mb-4">
          <Col xs={12} md={6}>
            <HolidayFrameBlock
              title={lang[11]}
              categories={holidayFrames}
              handleViewMore={handleViewMore}
              setFrame={setFrame}
              setFrameTransform={setFrameTransform}
              setFrameTransformText={setFrameTransformText}
              frame={frame}
            />
          </Col>
          <Col xs={12} md={6}>
            <FrameCategoryBlock
              title={lang[12]}
              categories={eventsFrames}
              handleViewMore={handleViewMore}
              setFrame={setFrame}
              setFrameTransform={setFrameTransform}
              setFrameTransformText={setFrameTransformText}
              frame={frame}
            />
          </Col>
          <Col xs={12} md={6}>
            <FrameCategoryBlock
              title={lang[13]}
              categories={thematicArr}
              handleViewMore={handleViewMore}
              setFrame={setFrame}
              setFrameTransform={setFrameTransform}
              setFrameTransformText={setFrameTransformText}
              frame={frame}
            />
          </Col>
          <Col xs={12} md={6}>
            <FrameCategoryBlock
              title={lang[14]}
              categories={standartFrames}
              isStandart={true}
              handleViewMore={handleViewMore}
              setFrame={setFrame}
              setFrameTransform={setFrameTransform}
              setFrameTransformText={setFrameTransformText}
              frame={frame}
            />
          </Col>
        </Row>

        <Row className="g-2 gy-3 g-lg-3 mb-4">
          <div className="fw-bold font_title">{lang[17]}</div>
          <Col xs={6} md={3}>
            <QrPatternBackground />
          </Col>
          <Col
            xs={12}
            md={6}
            className="d-flex justify-content-start align-items-center"
          >
            <QrPatternBackgroundToggle />
          </Col>
        </Row>

        {isStandartFrame && (
          <>
            <div className="fw-bold font_title mb-2 mb-md-3">
              <PalleteIcon className="me-2 fs-7 mb-1" />
              {lang[5]}
            </div>
            <Col xs={6} md={3}>
              <FrameQrColor />
            </Col>
          </>
        )}

        {!isTemplateService && (
          <>
            <div className="fw-bold font_title mb-2 mb-md-3">{lang[15]}</div>
            <Row className="g-2 g-lg-3 mb-3">
              {frameConfigs
                .filter(
                  (item) =>
                    item.name === "noFrame" ||
                    recentlyFrameNames.includes(item.name)
                )
                .slice(0, isDesktop ? 8 : 4)
                .map((i) => {
                  return (
                    <CustomCol xs={3} key={i.name}>
                      <FrameItem
                        onClick={() => {
                          setFrame(i.name);
                          setFrameTransform(i.transformQr);
                          setFrameTransformText(i.transformFrameText);
                        }}
                        className={classNames(
                          "d-flex justify-content-center align-items-center border rounded-1 p-2 h-100",
                          {
                            "border-primary": i.name === frame,
                            "border-border-gray": i.name !== frame,
                          }
                        )}
                      >
                        {i.name === "noFrame" ? (
                          <NoTemplate />
                        ) : (
                          <QrFrameWrapper
                            frame={i.name}
                            frameColor={"#727271"}
                            isTransformFrameWithTextTemplate={false}
                          />
                        )}
                      </FrameItem>
                    </CustomCol>
                  );
                })}
            </Row>
          </>
        )}

        <div className="fw-bold font_title mt-3 mt-md-4 mb-2 mb-md-3">
          {lang[2]}
        </div>
        <Row className="g-2 g-lg-3 ">
          <Col xs={12} md={4}>
            <FrameTextInput />
          </Col>
          <Col xs={4} md={3}>
            <FrameTextFont />
          </Col>
          <Col xs={4} md={2}>
            <FrameTextSize />
          </Col>
          <Col xs={4} md={3}>
            <FrameTextColor />
          </Col>
        </Row>
      </section>
    </>
  );
}

export default QrFrameItems;

export const FrameItem = styled.div`
  svg {
    width: ${(props) => (props.svgSize ? `${props.svgSize}%` : "100%")};
    height: ${(props) => (props.svgSize ? `${props.svgSize}%` : "100%")};
  }
`;

export const CustomCol = styled(Col)`
  @media (min-width: 992px) {
    width: 12.5% !important;
  }
`;
